import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ConfirmationModal from '~/components/ConfirmationModal';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import messages from './messages';
import { useDeletePublisher } from '~/hooks/api/useDeletePublisher';

type DeleteButtonProps = {
  publisherId: number;

  onDeleteSuccess: () => void;
};

export const DeleteButton = (props: DeleteButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [isConfirmationDialogVisible, setIsConfirmationDialogVisible] =
    useState(false);
  const deletePublisherMutation = useDeletePublisher({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.deleteSuccess),
      });
      props.onDeleteSuccess();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.deleteFailure),
      });
    },
    onSettled() {
      setIsConfirmationDialogVisible(false);
    },
  });
  return (
    <>
      <MenuItem onClick={() => setIsConfirmationDialogVisible(true)}>
        {intl.formatMessage(messages.deleteButton)}
      </MenuItem>

      <ConfirmationModal
        open={isConfirmationDialogVisible}
        title={intl.formatMessage(messages.deleteConfirmTitle)}
        text={<FormattedMessage {...messages.deleteConfirmText} />}
        confirmLabel={<FormattedMessage {...messages.deleteConfirmDelete} />}
        cancelLabel={<FormattedMessage {...messages.deleteConfirmCancel} />}
        onCancel={() => setIsConfirmationDialogVisible(false)}
        onConfirm={() =>
          deletePublisherMutation.mutate({ id: props.publisherId })
        }
      />
    </>
  );
};

export default DeleteButton;
